<ng-template #tableTemplate>
  <eas-table [table]="table | async"
    [canSelectColumns]="true"
    [defaultColumns]="defaultColumns"
    [selectedColumnsStorageKey]="storageKey"></eas-table>
</ng-template>

<app-list title="{{ title }}"
          [tableTemplate]="tableTemplate"
          [actions]="actions"></app-list>
